export const getArrayPriceList = (
  start: number,
  end: number = 1000,
  step: number = 1
): Array<number> => {
  const arr: Array<number> = [];

  for (let i = start; i <= end; i += step) {
    if ((i - start) % step === 0) arr.push(i);
  }

  if (end % step !== 0) {
    arr.push(end);
  }
  return arr;
};

export const getRepaymentArrayPriceList = (
  start: number,
  end: number = 1000,
  step: number = 1
): Array<number> => {
  const arr: Array<number> = [];

  for (let i = start; i <= end; i += step) {
    arr.push(+i?.toFixed(2));
  }

  if (end % step !== 0) {
    arr.push(end);
  }
  return arr;
};
